import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Dropdown } from 'primeng/dropdown';
import { Table } from 'primeng/table';
import { FilterVersion } from 'src/app/views/utility/modals';
import { VersionupdateService } from 'src/app/views/main-layout/versionupdate/versionupdate.service';
@Component({
  selector: 'app-versionupdatefilters',
  templateUrl: './versionupdatefilters.component.html',
  styleUrls: ['./versionupdatefilters.component.css']
})
export class VersionupdatefiltersComponent {
  @ViewChild('dropdown') dropdown: Dropdown;
  @ViewChild('dt') dt: Table;
  maxLabelWidth: number;
  filterVersion = new FilterVersion()
  filterinput = new Filterreq()
  @Output() dataEvent = new EventEmitter<{}>();
  ngAfterViewInit() {
  }
  getTextWidth(text: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = '14px Arial';
    const width = context.measureText(text).width;
    return width;
  }
  @Input() componentname: string = '';

  filtercategorydata: Array<any> = [];
  filterproductdata: Array<any> = [];
  filterversiondata: Array<any> = [];

  categoryList: Array<any> = []
  productList: Array<any> = []
  versionList: Array<any> = []

  errorDIsplay = false;
  isround: boolean = true
  filtresParams = [];
  selectitems = [];
  showToDateRequired: boolean = false;

  constructor(private versionupdateservice: VersionupdateService) {
    this.versionupdateservice.getFilterChange(this.filterVersion)
    this.getDropdownList();

  }

  getDropdownList() {
    this.versionupdateservice.filtersObservable.subscribe(res => {
      this.filterVersion = res;
      const product = this.versionupdateservice.getproductdatafilter(this.filterVersion);
      const version = this.versionupdateservice.getversiondatafilter(this.filterVersion);
      const category = this.versionupdateservice.getcategorydatafilter(this.filterVersion);

      version.subscribe(res => {
        this.versionList = []
        this.versionList = res.sort((a, b) => {
          return a.versionname.localeCompare(b.versionname);
        });
        this.versionList = res.map(e => ({ labelname: e.versionname, value: e.rid }));
        this.versionList.unshift({ value: '', labelname: 'Select' });
      })

      product.subscribe(res => {
        this.productList = res.sort((a, b) => {
          return a.productinitial.localeCompare(b.productinitial);
        });
        this.productList = res.map(e => ({ labelname: e.productinitial, value: e.productid }));
        this.productList.unshift({ value: '', labelname: 'Select' });
      });

      category.subscribe(res => {
        this.categoryList = res.sort((a, b) => {
          return a.categoryname.localeCompare(b.categoryname);
        });
        this.categoryList = res.map(e => ({ labelname: e.categoryname, value: e.id }))
        this.categoryList.unshift({ value: '', labelname: 'Select' });
      });
    });
  }

  refreshFilters() {
    this.errorDIsplay = false;
    this.filterVersion = new FilterVersion()
    this.filterVersion = {
      tfromdate: '',
      ttodate: '',
      tversionid: '',
      tproduct: '',
      tcategory: '',
      page: 1,
      size: 10,
    }
    this.versionupdateservice.getFilterChange(this.filterVersion);
    this.getDropdownList();
    this.versionupdateservice.filterrefresh();
  }

  onFilterSelect(data, label, event?) {
    switch (label) {
      case 'Product': const product = this.filterproductdata.find(item => item.value === data.productid); break;
      case 'Version': const version = this.filterversiondata.find(item => item.value === data.versionid); break;
      case 'Category': const category = this.filtercategorydata.find(item => item.value === data.categoryid); break;
      default: break;
    }

    Object.keys(this.filterinput).forEach(key => {
      if (this.filterinput[key] === undefined || this.filterinput[key] === null) {
        this.filterinput[key] = '';
      }
    });

    if (event.value === undefined || event.value === null) {
      event.value = '';
    }

    if (label == 'Product') { this.filterVersion['tproduct'] = event.value }
    if (label == 'Version') { this.filterVersion['tversionid'] = event.value }
    if (label == 'Category') { this.filterVersion['tcategory'] = event.value }
    this.getDropdownList();
    if (!this.selectitems.includes(label)) {
      this.selectitems.push(label);
    }

    this.filterVersion = data;
    this.versionupdateservice.selecteditems.next(this.selectitems);
    this.versionupdateservice.getFilterChange(this.filterVersion);
  }

  clearSearch() {
    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
    }
    // If you also want to clear the input field:
    const searchInput = document.getElementById('tablesearch') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
  }

  clearDate() {
    this.filterinput.ttodate = null;
  }

  onclear1(event) {
    this.errorDIsplay = false;
    this.filterVersion['tproduct'] = '';
    this.filterVersion['tversionid'] = '';
    this.filterVersion['tcategory'] = '';
    this.filterVersion['tfromdate'] = '';
    this.filterVersion['ttodate'] = '';
    this.versionupdateservice.getFilterChange(this.filterVersion)
  }

  onclear(event) {
    if (event.ttodate == null || event.tfromdate == null) {
      this.errorDIsplay = false;
      this.filterVersion['tfromdate'] = ''; this.filterVersion['ttodate'] = '';
      this.versionupdateservice.getFilterChange(this.filterVersion)
    }
    if (event.tfromdate === '' || event.tfromdate == null) {
      this.selectitems = this.selectitems.filter(item => item !== "From Date");
    }
    if (event.ttodate === '' || event.ttodate == null) {
      this.selectitems = this.selectitems.filter(item => item !== "To Date");
    }
    this.versionupdateservice.selecteditems.next(this.selectitems);

  }



  getdates(event) {
    if (event.tfromdate !== '' && event.ttodate !== '') {
      if (event.tfromdate <= event.ttodate) {
        this.errorDIsplay = false;
        this.filterVersion['tfromdate'] = moment(event.tfromdate).format('DD-MMM-YYYY');
        this.filterVersion['ttodate'] = moment(event.ttodate).format('DD-MMM-YYYY');

        if (this.filterVersion['tfromdate'] && this.filterVersion['tfromdate'] !== '') {
          if (!this.selectitems.includes('From Date')) {
            this.selectitems.push('From Date');
          }
        }

        if (this.filterVersion['ttodate'] && this.filterVersion['ttodate'] !== '') {
          if (!this.selectitems.includes('To Date')) {
            this.selectitems.push('To Date');
          }
        }


        this.versionupdateservice.selecteditems.next(this.selectitems);
        this.getDropdownList();
        this.versionupdateservice.getFilterChange(this.filterVersion);
      }
      else { this.errorDIsplay = true; }
    }
  }



  getTooltip(selectedValue: any, list: any[]): string {
    if (!selectedValue) {
      return 'Select';
    }
    const selectedItem = list.find(item => item.value === selectedValue);
    return selectedItem ? selectedItem.labelname : 'Select';
  }

  gettodatetooltip() {
    if (!this.filterinput.ttodate) {
      return 'Select To Date'
    }
    const selected = this.formatDate(this.filterinput.ttodate, 'DD-MMM-YYYY');
    return selected ? selected : 'Select To Date';

  }
  getfromdatetooltip() {
    if (!this.filterinput.tfromdate) {
      return 'Select From Date'
    }
    const selected = this.formatDate(this.filterinput.tfromdate, 'DD-MMM-YYYY');
    return selected ? selected : 'Select From Date';

  }
  formatDate(value: any, format: string = 'DD-MMM-YYYY') { // convert for save payload
    if (typeof value === 'string' && value.trim()) {
      return moment(value).format(format);
    } else if (value instanceof Date) {
      return moment(value).format(format);
    } else {
      return '';
    }
  }


}


export class Filterreq {
  tproduct = '';
  tcategory = '';
  tversionid = '';
  tfromdate: any = '';
  ttodate: any = "";

}

